import Swiper from 'swiper/bundle';
import { Navigation } from "swiper/modules";
import type { Swiper as SwiperInstance } from 'swiper/types';

class MCLMovingGallerySlider {
    gallery: HTMLElement;
    slider!: SwiperInstance;

    constructor(gallery: HTMLElement) {
        this.gallery = gallery;
        this.initSlider();
    }

    initSlider = (): void => {
        this.slider = new Swiper(this.gallery, {
            modules: [Navigation],
            autoplay: {
                delay: 3000,
                pauseOnMouseEnter: true,
            },
            loop: true,
            autoHeight: false,
            speed: 600,
            // freeMode: true,
            // centeredSlides: true,
            // lazyPreloadPrevNext: 10,
            slidesPerView: 'auto',
            spaceBetween: 10,

            navigation: {
                nextEl: '.mcl-moving-gallery__btn.next',
                prevEl: '.mcl-moving-gallery__btn.prev',
            },
        });
    };
}

export const mclMovingGalleries = () => {
    const galleries = document.querySelectorAll('.mcl-moving-gallery') as NodeListOf<HTMLElement>;

    if (galleries.length === 0) return;

    galleries.forEach(gallery => new MCLMovingGallerySlider(gallery));
}